// IE 9 don't support devicePixelRatio
// http://msdn.microsoft.com/en-us/library/ie/dn255104%28v=vs.85%29.aspx
// http://www.quirksmode.org/blog/archives/2012/07/more_about_devi.html
if(!("devicePixelRatio" in window)){
	window.devicePixelRatio = 1;
}
